import { BasicContact, BuildJsonType } from '@bb/domain/dist/types';
import { ContactDrawerType } from 'contexts';
import React from 'react';
import styled from 'styled-components';
import { Contact } from 'components';
import { SecondaryDescriptionText } from '@brokerbay/design-components';
import { MakeRequired } from 'utils';

export interface CoopContactEntryProps {
  contact: BuildJsonType<BasicContact>;
  isMobile?: boolean;
}

const CoopContactEntry = (props: CoopContactEntryProps) => {
  const { contact, isMobile } = props;
  // lastName may not be populated
  const lastName =
    contact.lastName || contact.name.replace(`${contact.firstName} `, '');

  return (
    <div
      onClick={e => e.stopPropagation()}
      data-cy={`coop-contact-${contact.name}`}
    >
      <Contact
        contact={
          {
            ...contact,
            lastName,
            brokerageName: contact.org?.name,
          } as MakeRequired<BuildJsonType<BasicContact>, 'firstName'>
        }
        type={contact.id ? ContactDrawerType.User : ContactDrawerType.Coop}
        underlineOnHover
        isMobile={isMobile}
      />
      {!isMobile && (
        <StyledAddressName ellipsis>{contact.org?.name}</StyledAddressName>
      )}
    </div>
  );
};

export default React.memo(CoopContactEntry);

export const StyledAddressName = styled(SecondaryDescriptionText)`
  && {
    display: block;
  }
  text-align: left;
  text-overflow: ellipsis;
`;
